export default __webpack_public_path__ + "static/media/parnter-two.2c1a9ea5.png";